<template>
  <v-footer paddless id="footer">
    <v-container>
      <v-row>
        <!-- Contact information -->
        <v-col cols="12" sm="6" md="4">
          <h6>Contact Info</h6>
          <p>
            Please address all questions to
            {{ $store.state.websiteVariables.corresponderName }} at
            <a
              :href="
                `mailto:${$store.state.websiteVariables.corresponderEmail}`
              "
              >{{ $store.state.websiteVariables.corresponderEmail }}</a
            >
          </p>
          <p>
            <v-icon :style="{ color: 'inherit' }">mdi-map-marker</v-icon>Address
            here?
          </p>
        </v-col>

        <!-- Navigation -->
        <v-col cols="12" sm="6" md="4">
          <h6>Navigation</h6>
          <ul class="links-list">
            <li v-for="link in navigationLinks" :key="link.title">
              <router-link :to="link.to">{{ link.title }}</router-link>
            </li>
          </ul>
        </v-col>

        <!-- Funding -->
        <v-col cols="12" sm="6" md="4">
          <h6>Funded by</h6>
          <v-row>
            <v-col cols="4"
              ><a href="https://mrc.ukri.org/" target="_blank"
                ><v-img eager src="@/assets/images/funding/mrc.png"></v-img></a
            ></v-col>
            <v-col cols="8" class="ma-auto"
              ><a href="https://www.nihr.ac.uk/" target="_blank"
                ><v-img eager src="@/assets/images/funding/nihr.png"></v-img></a
            ></v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr />
      <!-- Copyright notice -->
      <v-row>
        <v-col>
          <span>
            &copy;
            {{ new Date().getFullYear() }}
            National Prion Monitoring Cohort. All rights reserved.
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<style scoped>
#footer {
  background-color: #272727;
  border-top: 4px solid var(--v-primary-base);
  color: gray;
  font-size: 14px;
}

h6 {
  font-size: 16px;
  margin-bottom: 4px;
}

hr {
  border-color: gray;
}

.links-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.links-list a {
  color: inherit;
  text-decoration: none;
}

.links-list a:hover {
  color: var(--v-primary-base);
}
</style>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["navigationLinks"])
  }
};
</script>
